import styled from 'styled-components';

export const Createwrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: auto;
`;
export const CreateContendwrap = styled.div`
  display: flex;
  justify-content: center;
  margin: 20px 0px;
  width: 100%;
  min-width: 400px;
  min-height: 85%;
  background-color: var(--white-color);
  border: 2px solid var(--white-color);
  border-radius: 5px;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2), 0 2px 6px rgba(0, 0, 0, 0.12);
`;

export const CreateStyleDiv = styled.div`
  height: 100%;
  width: 95%;
`;
export const CreateFormwrap = styled.div`
  width: 80%;
  min-height: 80vh;
  margin: 10px 0px;
  @media screen and (max-width: 575px) {
    width: 90%;
  }
  &.maildelivery {
    margin-top: 20px;
    @media screen and (max-width: 720px) {
      width: 95%;
    }
  }
`;
